/**
 * This is a compiled JS file.
 * Changes here could be overwritten. 
 * Contact your Shopify developers if changes need to be made.
 */

  jQuery(document).ready(function(){
       setTimeout(function(){
         var iwC1 = $('.iw-link__count').text();
       //  console.log("iwC1: ",iwC1);
         if(iwC1>0){ $('.iw-link__bubble').show();}
         else { $('.iw-link__bubble').hide(); }
       },500);
         jQuery("body").on("click",".iWishAddColl, .iWishAdd, .iwish-backdrop,.iwish_drawer_close",function(){
               setTimeout(function(){
                var iwC1 = jQuery('.iw-link__count').text();
                //console.log("iwC1click: "+iwC1);
                if(iwC1>0){ jQuery('.iw-link__bubble').show();}
                else { jQuery('.iw-link__bubble').hide(); }
            },500);
          });

        jQuery("body").on("click",".iwish-backdrop,.iwish_drawer_close",function(){
        setTimeout(function(){
           var ct = $('.cart-link__bubble').text();
           if(ct>0){
             $('.cart-link__bubble').addClass('cart-link__bubble--visible');
           }
           $('.cart-link__bubble').empty();
          },700);
         });
     })
